import {
  archItemSchema,
  getBaseProductSchema,
  ItemTypeEnum,
  ProductTypeEnum,
  waxBiteItemSchema,
  type WaxBiteProduct,
} from "@jasper/client-models";
import z from "zod";
import {
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { ArchStep } from "./constants";

export type WaxBiteStepKey = typeof StepKeysEnum.arch;

/**
 * `min(1)` and not `length(1)`: a wax bite created by V1 on both arches holds two items
 * on a single product, and must stay readable and editable from V2.
 */
const waxBiteArchesSchema = z.object({
  items: z.array(archItemSchema).min(1),
});

export const WaxBiteWorkflowConfiguration: ProductWorkflowConfiguration<
  WaxBiteProduct,
  WaxBiteStepKey
> = {
  productType: ProductTypeEnum.waxBite,
  itemType: ItemTypeEnum.waxBite,
  steps: [new ArchStep()],
  teethSelection: TeethSelectionEnum.ARCH,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({ itemSchema: waxBiteItemSchema }).safeParse(
      product
    ).success;
  },

  getCompletedSteps(product) {
    return waxBiteArchesSchema.safeParse(product).success
      ? [StepKeysEnum.arch]
      : [];
  },
};
